var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconZip24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19a2.5 2.5 0 002.5 2.5h9A2.5 2.5 0 0020 19V7.499a.5.5 0 00-.14-.347l-4.335-4.499a.5.5 0 00-.36-.153H8.5A2.5 2.5 0 006 5v3.811a.5.5 0 101 0V5a1.5 1.5 0 011.5-1.5h6V6a2 2 0 002 2H19v11a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 017 19v-.5a.5.5 0 00-1 0v.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71 15.096H6.23l2.448-3.272v-.736h-3.72v.896h2.424l-2.464 3.272V16H8.71v-.904zm2.313-4.008H10V16h1.024v-4.912z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.188 12.696c0 1.04-.688 1.6-1.728 1.6h-.984V16H12.46v-4.912h2c1.04 0 1.728.56 1.728 1.608zm-1.792.728c.528 0 .784-.304.784-.728 0-.44-.256-.736-.784-.736h-.92v1.464h.92z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip24);
export default __webpack_public_path__ + "static/media/icon-zip-24.924ed2ff.svg";
export { ForwardRef as ReactComponent };